//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import role from "apis/role/role";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import benefitcode from "apis/BenefitCode/benefitcode";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function Create(props) {
  const { state, dispatch } = useContext(Context);

  const { createBenefitCode } = benefitcode();
  const history = useHistory();
  const classes = styles();
  
  const [states, setstates] = useState({
    id: "",
    tier: "",
    privilegeType: "",
    privilegeCode:"",
    createdAt:""  ,
    updatedAt:"",
    default:"",
    defaultAssign:"",
    loyaltyOrganizationName:"",
    loyaltySiteId:"",  
    isActive: true,
    loading: false,
  });

  const {
    id,
    tier,
    privilegeType,
    privilegeCode,
    createdAt,
    updatedAt,
    Default,
    defaultAssign,
    loyaltyOrganizationName,
    loyaltySiteId,   
    loading,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "BENEFITCODE", "CREATE"],
    });
  }, []);
  
  // create api func
  const handleCreateBenefitCode = async () => {
    try {
      if (
        !id ||
        !tier
      ) {
        toast.error("Please fill all the fields", {
          toastId: "required-fields-error",
        });
        setStates({ loading: false });
        return;
      }
      let values;
      values = {
        id,
        tier,
        privilegeCode,
        privilegeType,
        Default,
        defaultAssign
      };
      let res = await createBenefitCode(values);
      if (res && res?.type === "SUCCESS") {
        toast.success("Created", { toastId: "rule-created" });
        history.goBack();
      }
      if (res && res?.type === "ERROR") {
        toast.error("Benefitcode Already Exists", {
          toastId: "role-exists",
        });
      }
      setStates({ loading: false });
    } 
    catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18, fontWeight: "bold" }}>{'Create'}</span>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: 10 }}>
        <Grid item xs={4}>
          <CssTextField
            label={"Id"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={id}
            onChange={(e) => {
              setStates({ id: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <CssTextField
            label={"Tier"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={tier}
            onChange={(e) => {
              setStates({ tier: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <CssTextField
            label={"Privilege Type"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={privilegeType}
            onChange={(e) => {
              setStates({ privilegeType: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={4}>
        <CssTextField
            label={"Privilege Code"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={privilegeCode}
            onChange={(e) => {
              setStates({ privilegeCode: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <CssTextField
            id={"Is Active"}
            label={"Default"}
            select
            fullWidth
            type={"text"}
            required
            value={Default}
            onChange={(e) => {
              setStates({ Default: e.target.value });
            }}
          >
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((t, i) => (
              <MenuItem value={t.value} key={i}>
                {t.label}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>

        <Grid item xs={4}>
          <CssTextField
            id={"Is Active"}
            label={"Default Assign"}
            select
            fullWidth
            type={"text"}
            required
            value={defaultAssign}
            onChange={(e) => {
              setStates({ defaultAssign: e.target.value });
            }}
          >
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((t, i) => (
              <MenuItem value={t.value} key={i}>
                {t.label}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button
            className={classes.submitBtn}
            onClick={() => {
              setStates({ loading: true });
              handleCreateBenefitCode();
            }}
            disabled={loading}
          >
            {'Submit'}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
